import { useRef, useState,useEffect } from "react";
import { ToastContainer } from "react-toastify";
import SlidingPane from "react-sliding-pane";
import jsPDF from "jspdf";
// import "jspdf-autotable";
import { autoTable } from 'jspdf-autotable'
import _ from "lodash";
import Select from "react-select";
import "react-sliding-pane/dist/react-sliding-pane.css";
import MaterialTable, { MTableToolbar } from "material-table";

import Helper from "../../../Helper";
import { getTrans as t } from "../../../Localization/translations";
import authHeader from "../../../services/auth-header";
import { API } from "../../../backend";
import lineOfBusinessService from "../../../services/company/lineofbusinessService";
import subcompanyService from "../../../services/company/subcompanyService";

function AccountingEnteries({ id }) {
  var contractNumber = "";
  const date = new Date();
  const [state1, setState] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });
  const tableRef = useRef();
  const DR_CR = {
    D: "Debit",
    C: "Credit",
  };

  let period_year = "";
  let calendar_name = "";

  const [subcompany, setSubcompany] = useState("");
  const [lineOfBusiness, setLineOfBusiness] = useState("");
  const [subcompanyOptions, setSubcompanyOptions] = useState([]);
  const [lineOfBusinessOptions, setLineOfBusinessOptions] = useState([]);


    const fetchSubcompanies = () => {
        try {
          subcompanyService.getSubcompany().then((response) => {
          const companies = response.data || [];
  
            setSubcompanyOptions(companies);
        
          });
        } catch (err) {
          console.error(err);
        }
      };
    
      // Fetch Lines of Business
      const fetchLinesOfBusiness = () => {
        try {
          lineOfBusinessService.getLineOfBusiness().then((response) => {
            const lobs = response.data || [];
        setLineOfBusinessOptions(lobs);
          setLineOfBusinessOptions(lobs);
          
          });
        } catch (err) {
          
          console.error(err);
        }
      };
      useEffect(() => {
            fetchSubcompanies();
            fetchLinesOfBusiness();
        }, []);

  const [selectedValue, setSelectedValue] = useState(null);
  const [selectedValue2, setSelectedValue2] = useState(null);
  const [isLoading2, setIsLoading2] = useState(false);
  const [inputvalue2, setValue2] = useState("");
  const [currentPage2, setCurrentPage2] = useState(1);
  const [options2, setOptions2] = useState([]);

  const handleClear = () => {
    setSelectedValue(null);
    setSelectedValue2(null);
    tableRef.current.onQueryChange();
  };

  const handleInputChangeData = (value) => {
    setValue2(value);
    setCurrentPage2(1);
    setOptions2([]);
    loadOptionsData(value, 1);
  };

  const handleMenuScrollToBottom = () => {
    loadOptionsData(inputvalue2, currentPage2);
  };

  const loadOptionsData = async (value, page) => {
    try {
      if (value !== "") {
        setIsLoading2(true);
        const response = await fetch(
          `${API}contracts/contractsactive/filter/?id=${value}&page=${page}`,
          { headers: authHeader() }
        );
        const newData = await response.json();

        if (newData && newData.data && newData.data.length > 0) {
          const newOptions = newData.data;

          setOptions2((prevOptions) => [...prevOptions, ...newOptions]);
          setCurrentPage2((prevPage) => prevPage + 1);
        } else {
          console.error("No data received or empty array from API.");
        }
        setIsLoading2(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setIsLoading2(false);
    }
  };

  const handelChange2 = (value1) => {
    setSelectedValue2(value1);
    // setSelectedValue(value1);
  };

  function getAlignmentStyles(columns) {
    const alignmentStyles = {};
    columns.forEach((columnDef, index) => {
      if (columnDef.field === 'dr') {
        alignmentStyles[index] = { halign: 'right' }; // Right align for "financed_amount" field
      }
      else if (columnDef.field === 'cr') {
        alignmentStyles[index] = { halign: 'right' }; // Right align for "financed_amount" field
      }
      else {
        alignmentStyles[index] = { halign: 'left' }; // Left align for other fields
      }
    });
    return alignmentStyles;
  }

  return (
    <div className="">
      <div className="container-fluid py-4 pt-2">
        <div className="row py-2 mt-2">
          <ToastContainer />
          <div className="col-md-12">
            <div className=" mb-0">
              <div className="body">
                <div className="p-0">
                  <MaterialTable
                    tableRef={tableRef}
                    style={{
                      padding: "0.5rem 0.5rem",
                      backgroundColor: "var(--bs-table-bg)",
                      borderBottomWidth: "1px",
                      boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                    }}
                    title={
                      <h5 className="mb-0">
                        {t("Trial Balance Report")} <br />
                        <h6 className="mb-0">
                          {t("Date : ")}
                          {date ? Helper.DateNormal(date) : ""}
                        </h6>
                      </h5>
                    }
                    columns={[
                      {
                        // title: `${t("Account Name")}`,
                        title: `${t("Account Number")}`,
                        field: "account_code",
                        render: (rowData) => (
                          <>
                            <div className=" d-xl-none tc d-md-none d-lg-none">
                              {/* {t("Account Code")} */}
                              {t("Account Number")}
                            </div>
                            <div
                              className={
                                rowData && rowData.account_code === "Total"
                                  ? "font-weight-bold"
                                  : ""
                              }
                            >
                              {rowData && rowData.account_code}
                            </div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "left",
                        },
                        cellStyle: {
                          textAlign: "left",
                          fontSize: 12,
                        },
                      },
                      {
                        // title: `${t("Account Number")}`,
                        title: `${t("Account Name")}`,
                        field: "account_number",
                        render: (rowData) => (
                          <>
                            <div className="d-xl-none tc d-md-none d-lg-none">
                              {t("Account Name")}
                            </div>
                            <div>{rowData && rowData.account_number}</div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "left",
                        },
                        cellStyle: {
                          textAlign: "left",
                          fontSize: 12,
                        },
                      },
                      {
                        title: `${t("DR")}`,
                        field: "dr",
                        render: (rowData) => (
                          <>
                            <div
                              className={`d-xl-none tc d-md-none d-lg-none`}
                              style={{
                                textAlign: rowData.isSmallScreen
                                  ? "left"
                                  : "right",
                                fontSize: "12px",
                                fontWeight: rowData.isSmallScreen ? "bold" : "",
                              }}
                            >
                              {t("DR")}
                            </div>
                            <div
                              className={
                                rowData.account_code === "Total"
                                  ? "font-weight-bold d-none d-xl-block d-lg-block text-right"
                                  : ""
                              }
                              style={{ textAlign: "right", fontSize: "12px" }}
                            >
                              {rowData && Helper.Amount(rowData.dr)}
                            </div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "right",
                        },
                        // cellStyle: {
                        //   textAlign: "right",
                        //   fontSize: 12,
                        // },
                      },
                      {
                        title: `${t("CR")}`,
                        field: "cr",
                        render: (rowData) => (
                          <>
                            <div
                              className={`d-xl-none tc d-md-none d-lg-none`}
                              style={{
                                textAlign: rowData.isSmallScreen
                                  ? "left"
                                  : "right",
                                fontSize: "12px",
                                fontWeight: rowData.isSmallScreen ? "bold" : "",
                              }}
                            >
                              {t("CR")}
                            </div>
                            <div
                              className={
                                rowData && rowData.account_code === "Total"
                                  ? "font-weight-bold d-none d-xl-block d-lg-block text-right"
                                  : ""
                              }
                              style={{ textAlign: "right", fontSize: "12px" }}
                            >
                              {rowData && Helper.Amount(rowData.cr)}
                            </div>
                          </>
                        ),
                        headerStyle: {
                          verticalAlign: "inherit",
                          fontWeight: "bold",
                          textAlign: "right",
                        },
                        // cellStyle: {
                        //   textAlign: "right",
                        //   fontSize: 12,
                        // },
                      },
                    ]}
                    data={(query) =>
                      new Promise((resolve, reject) => {
                        const { orderBy, orderDirection } = query;
                        let subcompanyParam = subcompany || "";
                        let lineOfBusinessParam = lineOfBusiness || "";

                        if (selectedValue2 && selectedValue) {
                          contractNumber = selectedValue.id;
                          period_year = selectedValue2.period_name;
                        } else if (selectedValue2) {
                          contractNumber = selectedValue2.id;
                        } else if (selectedValue2) {
                          period_year = selectedValue2.period_name;
                        } else {
                          if (id !== undefined) {
                            calendar_name = id;
                          } else {
                            calendar_name = "";
                          }
                        }

                        let url = API + "accounting/glenteriesreportview/?";
                        url += "per_page=" + query.pageSize;
                        url += "&page=" + (query.page + 1);
                        url += "&search=" + query.search;

                        url += `&contract_number=${contractNumber !== "" ? contractNumber : ""
                          }`;
                        url += `&subcompany=${subcompanyParam}`;
                        url += `&line_of_business=${lineOfBusinessParam}`;
                        if (orderBy) {
                          url += `&orderBy=${orderBy.field}`;
                          url += `&orderDirection=${orderDirection}`;
                        }
                        fetch(url, { headers: authHeader() })
                          .then((response) => response.json())
                          .then((result) => {
                            resolve({
                              data:
                                query.orderBy && query.orderDirection
                                  ? _.orderBy(
                                    result.data,
                                    [query.orderBy.field],
                                    [query.orderDirection]
                                  )
                                  : result.data,
                              page: result.page - 1,
                              totalCount: result.total,
                            });
                          });
                      })
                    }
                    components={{
                      Toolbar: (props) => (
                        <div className="MuiToolbar-root MTableToolbar-spacer-21  my-temp-class">
                          <MTableToolbar {...props} />
                          <span
                            onClick={() => setState({ isPaneOpen: true })}
                            style={{
                              color: "#b4b7c5",
                              paddingRight: "10px",
                              cursor: "pointer",
                            }}
                          >
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/static/images/ic-filter.svg"
                              }
                              alt=""
                            />
                          </span>
                          {/* } */}
                        </div>
                      ),
                    }}
                    options={{
                      headerStyle: {
                        backgroundColor: "white",
                        color: "#245C7F",
                        fontSize: 12,
                      },
                      rowStyle: (rowData, index) => {
                        if (index % 2) {
                          return { backgroundColor: "#fff" };
                        }
                      },
                      sorting: true,
                      search: true,
                      toolbar: true,
                      paging: true,
                      pageSize: 10, // make initial page size
                      emptyRowsWhenPaging: false, // To avoid of having empty rows
                      pageSizeOptions: [10, 15, 20, 50],
                      paginationType: "stepped",
                      showFirstLastPageButtons: false,
                      exportAllData: true,
                      exportButton: true,
                      exportFileName: "Trial Balance",
                      exportCsv: (columns, data) => {
                        // Add title and date information
                        const title = "Trial Balance Report";
                        const currentDate = new Date().toLocaleDateString();
                        if (selectedValue2 !== null) {
                          var selectedVal2 = selectedValue2.contract_number
                        }
                        // Add title and date to the CSV content
                        const csvContentWithInfo = `${title}\n ${selectedValue2 !== null ? `Fiter By Contract Number : ${selectedVal2}\n` : ''} Date: ${currentDate}\n\n`;

                        const csvColumns = Helper.visibleColumn(columns);
                        const csvColumnTitles = csvColumns.map(column => column.title);
                        const csvData = data.map((rowData) => {
                          const rowDataArray = csvColumns.map((columnDef) => {
                            if (
                              columnDef.field ===
                              "transaction_id.transaction_number"
                            ) {
                              return rowData.transaction_id
                                ? rowData.transaction_id.transaction_number
                                : "";
                            } else if (
                              columnDef.field === "contract_id.contract_number"
                            ) {
                              return rowData.contract_id
                                ? rowData.contract_id.contract_number
                                : "";
                            } else if (
                              columnDef.field === "cr"
                            ) {
                              return rowData.cr
                                ? Helper.Amount(rowData.cr)
                                : "";
                            } else if (
                              columnDef.field === "dr"
                            ) {
                              return rowData.dr
                                ? Helper.Amount(rowData.dr)
                                : "";
                            } else if (columnDef.field === "d_c_code") {
                              return rowData.d_c_code
                                ? DR_CR[rowData.d_c_code]
                                : "";
                            } else {
                              return rowData[columnDef.field];
                            }
                          });
                          return rowDataArray;
                        });

                        const csvContent = `${csvContentWithInfo}${csvColumnTitles.join(",")}\n${csvData.map(row => {
                          return row.map(field => {
                            if (field === null || field === undefined) {
                              return '""'; // Represent null values as an empty string in double quotes
                            }
                            if (field.includes(',') || field.includes(' ')) {
                              return `"${field}"`;
                            } else {
                              return field;
                            }
                          }).join(',');
                        }).join('\n')}`;

                        // Create a Blob and download link
                        const blob = new Blob([csvContent], {
                          type: "text/csv;charset=utf-8;",
                        });
                        const link = document.createElement("a");
                        link.href = URL.createObjectURL(blob);
                        link.download = `Trial_Balance_${currentDate}.csv`;
                        link.style.display = "none";

                        // Trigger the download
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                      },
                      exportPdf: (columns, data) => {
                        const visibleColumns = Helper.visibleColumn(columns);

                        const doc = new jsPDF();
                        doc.setFont("helvetica", "bold");
                        doc.setFontSize(16);
                        // Add title and date information to the PDF
                        const title = "Trial Balance Report";
                        doc.text(title, 14, 10);

                        doc.setFontSize(12);
                        doc.setFont("helvetica", "normal");
                        const currentDate = new Date().toLocaleDateString();
                        doc.text(`Date : ${currentDate}`, 14, 15);

                        if (selectedValue2 !== null) {
                          const selectedVal2 = selectedValue2?.contract_number;
                          doc.text(`Filter By Contract Number : ${selectedVal2 === 'undefined' ? '' : selectedVal2}`, 14, 20);
                        }

                        const columnTitles = visibleColumns.map(
                          (columnDef) => columnDef.title
                        );
                        const space = 22; // Adjust the space value as needed
                        const tableStartY = 5 + space;
                        const pdfData = data.map((rowData) => {
                          const rowDataArray = visibleColumns.map((columnDef) => {
                            if (
                              columnDef.field ===
                              "transaction_id.transaction_number"
                            ) {
                              return (
                                rowData.transaction_id?.transaction_number || ""
                              );
                            } else if (
                              columnDef.field === "cr"
                            ) {
                              return rowData.cr
                                ? Helper.Amount(rowData.cr)
                                : "";
                            } else if (
                              columnDef.field === "dr"
                            ) {
                              return rowData.dr
                                ? Helper.Amount(rowData.dr)
                                : "";
                            }
                            else if (
                              columnDef.field === "contract_id.contract_number"
                            ) {
                              return rowData.contract_id
                                ? rowData.contract_id.contract_number
                                : "";
                            } else if (columnDef.field === "d_c_code") {
                              return rowData.d_c_code
                                ? DR_CR[rowData.d_c_code]
                                : "";
                            } else {
                              return rowData[columnDef.field];
                            }
                          });
                          return rowDataArray;
                        });

                        // Generate PDF table
                        // doc.autoTable({
                        autoTable(doc,{
                          head: [columnTitles],
                          body: pdfData,
                          columnStyles: getAlignmentStyles(visibleColumns), // Apply column alignment styles
                          startY: tableStartY, // Adjust the Y position to avoid overlapping with title/date
                        });

                        // Save the PDF with title and date
                        const currentDateFormatted = currentDate.replace(
                          /\//g,
                          "-"
                        ); // Remove slashes for file name
                        doc.save(`Trial_Balance_${currentDateFormatted}.pdf`);
                      },
                      actionsColumnIndex: -1,
                      columnsButton: true,
                    }}
                  />
                </div>
              </div>
              <SlidingPane
                className="some-custom-class"
                overlayClassName="some-custom-overlay-class"
                isOpen={state1.isPaneOpen}
                title="Filter By"
                subtitle=""
                onRequestClose={() => {
                  // triggered on "<" on left top click or on outside click
                  setState({ isPaneOpen: false });
                }}
              >
                <div className="col-xl-12">
                  <div className="col-md-12">
                      <label className="col-form-label">{t("Sub Company")}</label>
                      <select
                        className="form-select form-control"
                        // value={subcompany}
                        name="subcompany"
                          onChange=  {(e) =>
                            setSubcompany(e.target.value)    
                        }
                      >
                        <option value="">Select Company</option>
                        {subcompanyOptions.map((sub) => (
                          <option key={sub.id} value={sub.id}>
                            {sub.sub_company_name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-12">
                      <label className="col-form-label">{t("Line of Business")} </label>
                      <select
                        className="form-select form-control"
                        // value={lineOfBusiness}
                        name="lineOfBusiness"
                        onChange= {(e)=>
                              setLineOfBusiness(e.target.value)
                        }
                      
                      >
                        <option value="">Select Line of Business</option>
                        {lineOfBusinessOptions.map((lob) => (
                          <option key={lob.id} value={lob.id}>
                            {lob.lob_name}
                          </option>
                        ))}
                      </select>
                  </div>
                  <div className="form-group row">
                    <label className="col-lg-12 col-form-label">
                      {t("Contract Number")}
                    </label>
                    <div className="col-lg-12">
                      <Select
                        value={selectedValue2}
                        filterOption={false}
                        options={options2}
                        isClearable
                        onInputChange={handleInputChangeData}
                        getOptionLabel={(options) => options.contract_number}
                        getOptionValue={(options) => options.contract_number}
                        isLoading={isLoading2}
                        placeholder={t("Search for Contract(%for All)")}
                        onMenuScrollToBottom={handleMenuScrollToBottom}
                        onChange={handelChange2}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-xl-12">
                  <div className="form-group row">
                    <div
                      className="col-lg-12 text-left"
                      style={{ marginTop: "30px" }}
                    >
                      <button
                        type="button"
                        className="clearReceipt btn bg-gradient-secondary btn-m ms-auto mb-0"
                        onClick={handleClear}
                      >
                        {t("Reset")}
                      </button>
                      &nbsp;&nbsp;
                      <button
                        type="button"
                        className="filter add btn btn-primary btn-m ms-auto mb-0"
                        onClick={() => Helper.handleSearch(tableRef)}
                      >
                        {t("Apply")}
                      </button>
                      &nbsp;&nbsp;
                    </div>
                  </div>
                </div>
              </SlidingPane>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccountingEnteries;
